import { Box, Menu, MenuItem } from "@mui/material";
import { max, min } from "lodash";
import { useRef, useState } from "react";
import { useOnClickOutside } from "../hook/event/OnClickOutsideHook";
import { ItemDto, ItemLightDto } from "./ItemDataTypes";

interface MultiStateItemProps {
    id: string
    items: Array<ItemDto>,
    updateItem?: (value: ItemLightDto) => void,
    item?: ItemLightDto
    isMajor?: boolean
}

const MultiStateItem = (props: MultiStateItemProps) => {

    let [isObtained, setIsObtained] = useState(false);
    let [selectState, setSelectState] = useState(0);

    let [anchorElement, setAnchorEl] = useState<null | HTMLElement>(null);
    let [open, setOpen] = useState(false);

    const ref = useRef();

    useOnClickOutside(ref, () => setOpen(false))

    const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        if (isObtained) {
            handleRightClick(e)
            return;
        }
        setAnchorEl(e.currentTarget)
        setOpen(true);
    }

    const handleRightClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        e.preventDefault()
        setSelectState(0);
        setIsObtained(false);
        setAnchorEl(null);
    }

    const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
        if (e.deltaY < 0 && selectState === 0 && isObtained)
            setIsObtained(false);
        else if (e.deltaY < 0 && selectState === 0 && !isObtained) {
            setSelectState(props.items.length - 1);
            setIsObtained(true)
        }
        else if (e.deltaY < 0)
            setSelectState(max([0, selectState - 1]) ?? 0)
        else if (e.deltaY > 0 && selectState === props.items.length - 1) {
            setSelectState(0);
            setIsObtained(false)
        }
        else if (e.deltaY > 0 && selectState === 0 && !isObtained) {
            setIsObtained(true)
        }
        else {
            setSelectState(min([props.items.length - 1, selectState + 1]) ?? 0)
            setIsObtained(true)
        }

    }

    const handleSelection = (index: number) => {
        setSelectState(index);
        setIsObtained(true);
        setAnchorEl(null);
        setOpen(false)
    }

    let selected = props.items[selectState]
    return <Box component="div" ref={ref} onWheel={handleWheel}>
        <selected.component id={props.id} image={selected.defaultIcon} isObtained={isObtained} title={selected.title} onClick={handleClick} onRightClick={handleRightClick} />
        <Menu
            id={"multiItemState" + props.id}
            open={open}
            anchorEl={anchorElement}
            sx={{ display: "inline-flex" }}
        >
            {props.items.map((it, i) => {
                return <MenuItem><it.component id={props.id} image={it.defaultIcon} isObtained title={it.title} onClick={(e) => handleSelection(i)} /></MenuItem>
            })}
        </Menu>
    </Box>
}

export default MultiStateItem;